//
// Module for the Flat Service Tables index view
//
rs.module("system/configuration/flatservicetables/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {
            // Hook up click event on the radio buttons to reload the grid data via ajax
            $.js(jsSelectors.filter).js(jsSelectors.currentFlatServiceTablesIndicators).find("input").on('click', function () {

                $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).show();

                // Update grid, set row selection, update detail of selected row
                gridModule.update(
                    ajaxUrls.getGridData,
                    { showAll: this.value },
                    lrsGridApi.agGridApi,
                    function done() {
                        $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);